import { last } from "lodash";
export function abortable(restServer, call) {
    return ((...args) => {
        const lastArg = last(args);
        const abortController = lastArg instanceof AbortController ? lastArg : undefined;
        const callRes = call(...args);
        const methodArguments = typeof callRes === "string"
            ? [callRes, {}]
            : callRes;
        return restServer(methodArguments[0], {
            ...methodArguments[1],
            signal: abortController?.signal,
        });
    });
}
